// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSDocumentType;
(function (TCSDocumentType) {
    TCSDocumentType[TCSDocumentType["None"] = 0] = "None";
    TCSDocumentType[TCSDocumentType["Claim"] = 1] = "Claim";
    TCSDocumentType[TCSDocumentType["Correspondence"] = 2] = "Correspondence";
})(TCSDocumentType || (TCSDocumentType = {}));
//# sourceMappingURL=tCSDocumentType.js.map